import React from 'react';
import * as s from './styled-support';

const Suporte = () => {
  return (
    <s.Container className="fade-in">
      <s.Title>
        Desculpe, esta funcionalidade ainda está em desenvolvimento!
      </s.Title>
    </s.Container>
  );
};

export default Suporte;
